var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBurger = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 3,
  rx: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 6,
  width: 18,
  height: 3,
  rx: 1.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 12,
  width: 18,
  height: 3,
  rx: 1.5
})));
export default SvgBurger;